import React from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';
import { Reveal } from './ui/Section';

const BENEFITS = [
  'すべての機能を30日間無料',
  '初期費用0円',
  'クレジットカード不要',
  '導入サポート付き',
];

const Cta: React.FC = () => (
  <section id="trial" className="relative overflow-hidden bg-ink-900">
    <div
      className="pointer-events-none absolute inset-0"
      style={{
        backgroundImage:
          'radial-gradient(circle at 20% 30%, rgba(242,107,33,0.20), transparent 45%), radial-gradient(circle at 80% 70%, rgba(47,91,133,0.45), transparent 50%)',
      }}
    />
    <div className="container-content relative py-20 lg:py-24">
      <Reveal>
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-pill border border-brand-400/40 bg-brand-500/15 px-4 py-1.5 text-small font-bold text-brand-300">
            30日間無料体験 受付中
          </span>

          <h2 className="text-h2 mt-6 text-white">
            まずは、無料で
            <br className="sm:hidden" />
            お試しください
          </h2>

          <p className="text-lead mt-5 text-ink-100">
            30日間、すべての機能を制限なくお試しいただけます。
            <br className="hidden sm:block" />
            ご利用いただいたご意見・ご要望は、製品の改善に反映していきます。
          </p>

          <ul className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3">
            {BENEFITS.map((b) => (
              <li key={b} className="flex items-center gap-2 text-small text-ink-100">
                <svg
                  viewBox="0 0 20 20"
                  className="h-4 w-4 shrink-0 text-brand-400"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="m3 10 5 5 9-11" />
                </svg>
                {b}
              </li>
            ))}
          </ul>

          <div className="mt-10 flex flex-col justify-center gap-3 sm:flex-row">
            <a href="/monitor.html" className="btn btn-lg btn-primary">
              30日間無料体験を申し込む
              <ArrowRightOutlined />
            </a>
          </div>

          <p className="mt-5 text-small text-ink-300">
            お申し込みは1分で完了します／初期費用0円
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Cta;
